import React from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';

import { ItemsCreators } from '../../../../store/actions/items';

import InputVoicebotAudioText from './InputVoicebotAudioText';

const TTSAudioASRSquare = ({
  item,
  activeCreateMenuConnection,
  menuHighlight,
  isCreating,
  connectors,
  updateItemWithDebounce,
}) => {
  const dispatch = useDispatch();

  const hasConnector = (option) => {
    return connectors.some(
      (connector) =>
        connector.from === item._id &&
        option.description === connector.voiceSettings?.nmIvrResult
    );
  };

  const isSelectedConnector = (option) => {
    return menuHighlight.some(
      (menuConnector) =>
        item?._id === menuConnector?.from &&
        option.description === menuConnector.voiceSettings?.nmIvrResult
    );
  };

  const handleClickMenuOption = (option) => {
    const { _id, description } = option;

    dispatch(
      ItemsCreators.setSelectedMenuOption({
        itemId: item._id,
        optionId: _id,
        description,
      })
    );
  };

  const handleInputChange = (event) => {
    const { value } = event.target;

    updateItemWithDebounce({
      voiceSettings: {
        ...item.voiceSettings,
        deScriptTts: value,
      },
    });
  };

  return (
    <>
      <div className="container-out-square-text">
        <div className="container-square-menu">
          <InputVoicebotAudioText
            value={item?.voiceSettings?.deScriptTts}
            onChange={handleInputChange}
            id={`input-voicebot-square-${item?._id}`}
          />

          <div className="div-block-menu-voice-item">
            {item?.menuItems?.map((option) => {
              return (
                <div className="container-remove-button-item" key={option._id}>
                  <div
                    className={classnames('block-menu-item block-p-menu', {
                      'block-menu-item-highlight': isSelectedConnector(option),
                      'block-menu-item-has-connector': hasConnector(option),
                      'block-menu-item-error':
                        option?.require_connection && !hasConnector(option),
                    })}
                    onClick={() => handleClickMenuOption(option)}
                  >
                    <input
                      defaultValue={option.description}
                      placeholder="Descrição..."
                      disabled
                    />
                    <button
                      className="block-menu-item-dot"
                      disabled={isCreating || hasConnector(option)}
                      onClick={(e) =>
                        activeCreateMenuConnection(e, {
                          ...option,
                          _id: item._id, // para utilizar o 'from' do bloco, não da opção
                        })
                      }
                      type="button"
                    >
                      <i />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default TTSAudioASRSquare;
